import React, { useEffect, useState } from 'react'
import Footer from '../components/footer/Footer';
import useStyles from '../styles/loan_rates';
import { styled } from '@mui/system'


const LoanRatesContainer: React.FC = () => {
    const classes = useStyles()
    const [activeOption, setActiveOption] = useState<string>('new-car')

    useEffect(() => {
        const sectionEl = document.getElementById("loan-rates-hero")
        const handleScroll = () => {
            const position = 217.168 + window.scrollY * 0.65
            if(sectionEl){
                if(position >= 500){
                    sectionEl.style.backgroundPosition = `0px -500px`
                }else{
                    sectionEl.style.backgroundPosition = `0px -${position}px`
                }
            }
            
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => window.removeEventListener('scroll', handleScroll);
      }, [activeOption]);
    const Hero = styled('section')(({ theme }) => ({
        position: 'relative',
        backgroundImage: 'url(imgs/loanrates.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: '0px -217.168px',
        padding: '150px 0px',
        top: '-100px',
        marginBottom: '-100px',
        textShadow: 'none !important',
        borderBottom: 'none',
        backgroundColor: 'transparent',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        transition: 'all 0.17s linear !important',

        [theme.breakpoints.down('md')]: {
            padding: '100px 0px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '60px 0px',
        },
    }));
    const MainContent = styled('section')(({ theme }) => ({
        position: 'relative',
        overflow: 'hidden',
        background: '#fff',
        margin: '0',
    }));



    const handleOptionChange=(name: string)=>{
        setActiveOption(name)
    }

    useEffect(()=> {
        document.getElementById(activeOption)?.focus()
    }, [activeOption])

  return (
        <main>
            <Hero id='loan-rates-hero'>
                <div className={classes.heroInner}>
                    <h1 className={classes.heroInnerH1}>Loan Rates</h1>
                </div>
            </Hero>

            <MainContent id='main'>
                <div className={classes.mainContentInner}>
                        <div className={classes.mainContentInnerContainer}>
                            <div style={{display: 'block', clear: 'both', float: 'none', paddingRight: '0', position: 'relative', width: '100%', paddingBottom: '4rem'}}>
                                

                                <div>
                                    <ul className={classes.ulToggle}>
                                        <li className={classes.liToggle} onClick={()=> handleOptionChange('new-car')}>
                                            <button id='new-car' className={activeOption === 'new-car' ? classes.pToggleActive : classes.pToggle}>New Car</button>
                                        </li>
                                        <li className={classes.liToggle} onClick={()=> handleOptionChange('used-vehicles')}>
                                            <button id='used-vehicles' className={activeOption === 'used-vehicles' ? classes.pToggleActive : classes.pToggle}>Used Vehicles</button>
                                        </li>
                                        <li className={classes.liToggle} onClick={()=> handleOptionChange('shared-secured')}>
                                            <button id='shared-secured' className={activeOption === 'shared-secured' ? classes.pToggleActive : classes.pToggle}>Shared Secured</button>
                                        </li>
                                        <li className={classes.liToggle} onClick={()=> handleOptionChange('personal')}>
                                            <button id='personal' className={activeOption === 'personal' ? classes.pToggleActive : classes.pToggle}>Personal</button>
                                        </li>
                                        <li className={classes.liToggle} onClick={()=> handleOptionChange('home-equity')}>
                                            <button id='home-equity' className={activeOption === 'home-equity' ? classes.pToggleActive : classes.pToggle}>Home Equity</button>
                                        </li>
                                    </ul>
                                </div>

                                <div style={{position:'relative', padding: '20px 0'}}>
                                {
                                    
                                    activeOption === 'new-car'
                                    ?

                                    
                                        <div>
                                            <table className="ratetable twoCol" id="new-cars">
                                                <caption className={classes.caption}>
                                                    <div className="inputdiv">2024-2023 Untitled Vehicles</div>
                                                </caption>
                                                <tbody>
                                                    <tr> 
                                                        <th className={classes.th}>Term</th>
                                                        <th className={classes.th}>APR*</th>
                                                    </tr>
                                                    <tr> 
                                                        <td>60 Months</td>
                                                        <td>As Low As 5.50%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>72 Months</td>
                                                        <td>As Low As 6.00%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>84 Months</td>
                                                        <td>As Low As 6.50%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr> 
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr> 
                                                        <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    :
                                    activeOption === 'used-vehicles'
                                    ?

                                        <div>
                                            <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>
                                                        <div className="inputdiv">2023-2022 Titled Vehicles</div>
                                                    </caption>
                                                    <tbody><tr> 
                                                        <th className={classes.th}>Term</th>
                                                        <th className={classes.th} style={{textAlign: 'center'}}>APR*</th>
                                                    </tr>
                                                    <tr> 
                                                        <td>60 Months</td>
                                                        <td>As Low As 6.00%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>72 Months</td>
                                                        <td>As Low As 6.25%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>84 Months</td>
                                                        <td>As Low As 6.75%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr> 
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr> 
                                                        <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                    </tr>
                                                    </tbody>
                                            </table>
                                            
                                            <br/>

                                            <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>
                                                        <div className="inputdiv">2021-2020 Titled Vehicles</div>
                                                    </caption>
                                                    <tbody>
                                                        <tr> 
                                                            <th className={classes.th}>Term</th>
                                                            <th className={classes.th}>APR*</th>
                                                        </tr>
                                                        <tr> 
                                                            <td>60 Months</td>
                                                            <td>As Low As 6.50%</td>
                                                        </tr>
                                                        <tr> 
                                                            <td>72 Months</td>
                                                            <td>As Low As 6.75%</td>
                                                        </tr>
                                                        <tr> 
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr> 
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr> 
                                                            <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                        </tr>
                                                    </tbody>
                                            </table>
                                            <br/>

                                            <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>
                                                        <div className="inputdiv">2019-2018 Titled Vehicles</div>
                                                    </caption>
                                                    <tbody>
                                                        <tr> 
                                                            <th className={classes.th}>Term</th>
                                                            <th className={classes.th}>APR*</th>
                                                        </tr>
                                                        <tr> 
                                                            <td>60 Months</td>
                                                            <td>As Low As 7.25%</td>
                                                        </tr>
                                                        <tr> 
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr> 
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr> 
                                                            <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                        </tr>
                                                    </tbody>
                                            </table>
                                            <br />

                                            <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>
                                                        <div className="inputdiv">2017-2016 Titled Vehicles</div>
                                                    </caption>
                                                    <tbody>
                                                        <tr> 
                                                            <th className={classes.th}>Term</th>
                                                            <th className={classes.th}>APR*</th>
                                                        </tr>
                                                        <tr> 
                                                            <td>60 Months</td>
                                                            <td>As Low As 7.75%</td>
                                                        </tr>
                                                        <tr> 
                                                            <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                        </tr>
                                                    </tbody>
                                            </table>
                                                    


                                            <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>
                                                        <div className="inputdiv">2015-2014 Titled Vehicles</div>
                                                    </caption>
                                                    <tbody>
                                                        <tr> 
                                                            <th className={classes.th}>Term</th>
                                                            <th className={classes.th}>APR*</th>
                                                        </tr>
                                                        <tr> 
                                                            <td>48 Months</td>
                                                            <td>As Low As 8.50%</td>
                                                        </tr>
                                                        <tr> 
                                                            <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                        </tr>
                                                    </tbody>
                                            </table>

                        
                                        </div>

                                    :
                                    activeOption === 'shared-secured'
                                    ?

                                        <div>
                                                <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>Share Secured</caption>
                                                            <tbody>
                                                                <tr> 
                                                                    <th className={classes.th}>Term</th>
                                                                    <th className={classes.th}>APR*</th>
                                                                </tr>
                                                                <tr> 
                                                                    <td>Up to 72 Months</td>
                                                                    <td>As Low As 3.00%</td>
                                                                </tr>
                                                                <tr> 
                                                                    <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                                </tr>
                                                            </tbody>
                                                </table>
                                        </div>

                                    :
                                    activeOption === 'personal'
                                    ?

                                        <div>
                                            <table className="ratetable twoCol">
                                                <caption className={classes.caption}>Personal Loan Rates</caption>
                                                        <tbody>
                                                            <tr> 
                                                                <th className={classes.th}>Type</th>
                                                                <th className={classes.th}>APR*</th>
                                                            </tr>
                                                            <tr> 
                                                                <td>Personal Loans over $1,000 (Unless Special is in Effect)</td>
                                                                <td>As Low As 20.00%</td>
                                                            </tr>
                                                            <tr> 
                                                                <td>VISA Classic</td>
                                                                <td>15.00%</td>
                                                            </tr>
                                                            <tr> 
                                                                <td>VISA Classic Preferred (Ask how to become a Preferred Member)</td>
                                                                <td>13.00%</td>
                                                            </tr>
                                                            <tr> 
                                                                <td>Cash N Dash Payday Alternative Loan</td>
                                                                <td>20.00%</td>
                                                            </tr>
                                                            <tr> 
                                                                <td>*APR is the Annual Percentage Rate.</td>
                                                                <td></td>
                                                            </tr>
                                                            <tr> 
                                                                <td colSpan={3} className={classes.tablefoot}></td>
                                                            </tr>
                                                        </tbody>
                                            </table>
                                        </div>

                                    :
                                    activeOption === 'home-equity'
                                    ?

                                        <div>
                                            <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>Home Equity Rates (85% LTV**)</caption>
                                                    <tbody><tr> 
                                                        <th className={classes.th}>Term</th>
                                                        <th className={classes.th}>APR*</th>
                                                    </tr>
                                                    <tr> 
                                                        <td>5 Year</td>
                                                        <td>As Low As 7.50%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>6 Year - 7 Year</td>
                                                        <td>As Low As 8.00%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>8 Year - 10 Year</td>
                                                        <td>As Low As 8.75%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                    </tr>
                                                    </tbody>
                                            </table>
                                            <br/>
                                
                                            <table className="ratetable twoCol">
                                                    <caption className={classes.caption}>Home Equity Rates (80% LTV**)</caption>
                                                    <tbody><tr> 
                                                        <th className={classes.th}>Term</th>
                                                        <th className={classes.th}>APR*</th>
                                                    </tr>
                                                    <tr> 
                                                        <td>5 Year</td>
                                                        <td>As Low As 6.75%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>6 Year - 7 Year</td>
                                                        <td>As Low As 7.50%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td>8 Year - 10 Year</td>
                                                        <td>As Low As 8.25%</td>
                                                    </tr>
                                                    <tr> 
                                                        <td colSpan={3} className={classes.tablefoot}>*APR is the Annual Percentage Rate.</td>
                                                    </tr>
                                                    </tbody>
                                            </table>
            
                        

                                        </div>

                                    :

                                    null
                                    
                                }
                                </div>



                                <div>
                                    <p className={classes.paragraph}>Rates effective 08/01/2023.</p>
                                    <p className={classes.paragraph}>Rates are subject to change.</p>
                                </div>

                                {
                                    activeOption === 'personal'
                                    ?

                                    <div style={{width: '100%', textAlign: 'center', margin: '30px 0'}}>
                                        <strong className={classes.strong}>Ask your Loan Officer how you may qualify for a rate reduction!</strong>
                                        <p className={classes.paragraph}>(Rate reduction does not apply to VISA Credit Cards, Share Secured Loans and Cash N' Dash Payday Alternative Loans.)</p>
                                    </div>
                                    :
                                    null
                                }

                                <p className={classes.paragraph} style={{marginTop: '20px'}}>**LTV - Loan To Value</p>

                                <div style={{margin: '40px 0'}}>
                                    <p className={classes.paragraph}>NLMS#: 506334</p>
                                    <p className={classes.paragraph}>Note: New Loan Rates Effective 08/01/2023. Rates Subject To Change.</p>
                                    <p className={classes.paragraph}>Rates pertain to any new loan business on or after 08/01/2023, not previous loans.</p>
                                    <p className={classes.paragraph}>Call your Credit Union for more information. 815-933-7711 or 815-939-6049</p>
                                    <p className={classes.paragraph}>*Interest rates may vary based on the member(s) credit score and type of loan.</p>
                                </div>
                                
                                <img src="/imgs/eh.gif" alt="" className={classes.footerImg}/>
                            </div>
                        </div>
                </div>


            </MainContent>

    


            <Footer />
        </main>
  )
}

export default LoanRatesContainer
